import { Skeleton, Stack, type Theme, useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useSelector } from 'react-redux';
import Header from '/@/components/bayer/header';
import PageContainer from '/@/components/bayer/page-container';
import { useOwnUserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { getUser } from '/@/store/session/selectors';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import RVsLatestActivities from '../../components/dashboard-cards/rvs-latest-activities';
import RVsRecommnedationCard from '../../components/dashboard-cards/rvs-recommendations-card';
import FieldSection from '../../rv/components/field-section';
import UserUIAlertAndModal from '../../rv/components/onboarding-modal-and-alert/user-ui-alert-and-modal';
import ActivitySection from '../components/activity-selection';

const ConsultantHome = () => {
    const user = useSelector(getUser);
    const userNodeQuery = useOwnUserNode();
    const userNodeId = userNodeQuery.data?.id;
    const isSmOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    return (
        <PageContainer
            boxProps={{ sx: { background: '#F5F5F5' } }}
            header={
                <Header
                    title={
                        <>
                            {_('Hola, ')}
                            <span className='mp-mask'>{user?.first_name || ''}</span>
                        </>
                    }
                    subtitle={_('Accedé a una visión integral de tus RVs para brindar el asesoramiento que necesitan.')}
                    actions={[]}
                />
            }
        >
            <Stack my={3}>
                <UserUIAlertAndModal />
            </Stack>
            <Stack className='mp-mask' spacing={4}>
                <Grid2 spacing={3} container mx={{ sm: '-12px !important' }}>
                    <Grid2 xs={12} sm={12} md={6} lg={4} sx={[isSmOrLower && { px: 0 }]}>
                        <ActivitySection userNodeId={userNodeId} />
                    </Grid2>
                    <Grid2 xs={12} sm={12} md={6} lg={4} sx={[isSmOrLower && { px: 0 }]}>
                        {userNodeId ? (
                            <RVsRecommnedationCard userNodeId={userNodeId} />
                        ) : (
                            <Skeleton variant='rectangular' height={500} />
                        )}
                    </Grid2>
                    <Grid2 xs={12} sm={12} md={12} lg={4} sx={[isSmOrLower && { px: 0 }]}>
                        {userNodeId ? (
                            <RVsLatestActivities userNodeId={userNodeId} />
                        ) : (
                            <Skeleton variant='rectangular' height={500} />
                        )}
                    </Grid2>
                </Grid2>
                <FieldSection
                    userNodeId={userNodeId}
                    nodeScope={getNodeScopeFilters('rvs')}
                    title={_('Lotes de tus RVs')}
                    subtitle={_('Visualizá los lotes de los productores que trabajan con tus RVs.')}
                />
            </Stack>
        </PageContainer>
    );
};

export default ConsultantHome;
